var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stage_box"},[_c('i',{class:`stage_icon stage_${_vm.navNum}`})])
}
var staticRenderFns = []

export { render, staticRenderFns }